import React, { useState } from 'react';
import MarkdownContent from './MarkdownContent';
import WidgetBlocks from './WidgetBlocks';
import ComponentTreeRenderer from './ComponentTreeRenderer';

function Message({ message, onOpenPaymentModal, onA2UIEvent }) {
  const { content, isUser, isTyping, widgets, streamChunks, agentStates } = message;
  const [currentChunks, setCurrentChunks] = useState(streamChunks || []);

  const handleA2UIEvent = (event) => {
    // Handle A2UI events (button clicks, form submissions, etc.)
    if (onA2UIEvent) {
      onA2UIEvent(event, message);
    }

    // Special handling for payment-related events
    // if (event.type === 'button_click' && event.label && event.label.toLowerCase().includes('payment')) {
    //   if (widgets && onOpenPaymentModal) {
    //     onOpenPaymentModal({ widgets });
    //   }
    // }
  };

  // Update chunks when message updates
  React.useEffect(() => {
    if (streamChunks) {
      setCurrentChunks(streamChunks);
    }
  }, [streamChunks]);

  const shouldShowAgentStates = () => {
    if (isTyping) return true;
    if (isUser) return false; // User messages don't show agent states
    // Hide if response has started
    const hasResponse = content || (currentChunks && currentChunks.length > 0) || widgets;
    return !hasResponse;
  };

  // Render agent states
  const renderAgentStates = () => {
    if (!agentStates || agentStates.length === 0 || !shouldShowAgentStates()) {
      return null;
    }

    return (
      <div className="agent-states">
        {agentStates.map((state, index) => {
          const displayText = state.state === 'tool_call'
            ? `call tool: ${state.tool_name || 'unknown'}`
            : `tool response: ${state.tool_name || 'unknown'}`;

          return (
            <div key={index} className={`agent-state agent-state-${state.state}`}>
              {displayText}
            </div>
          );
        })}
      </div>
    );
  };

  const getMessageContent = () => {
    if (isTyping) {
      return (
        <div>
          {renderAgentStates()}
          <div className="typing-indicator">
            <span className="typing-text">Thinking</span>
            <span className="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
      );
    }

    // Check if we have stream chunks (component tree format)
    const hasStreamChunks = currentChunks && currentChunks.length > 0;
    // const hasComponentTree = hasStreamChunks && currentChunks.some(chunk => 
    //   chunk.type === 'component_tree' || chunk.type === 'add' || chunk.type === 'update'
    // );

    // console.log('🔍 Message render check - hasStreamChunks:', hasStreamChunks, 'hasComponentTree:', hasComponentTree, 'currentChunks:', currentChunks);

    if (hasStreamChunks) {
      // console.log('✅ Using ComponentTreeRenderer, chunks:', currentChunks);
      // Use ComponentTreeRenderer for streaming component tree
      return (
        <div>
          {renderAgentStates()}
          {/* Always render content if available, to ensure text appears before widgets */}
          {content && <MarkdownContent text={content} />}
          <ComponentTreeRenderer
            chunks={currentChunks}
            onEvent={handleA2UIEvent}
          />
        </div>
      );
    }

    // Fallback to regular widgets format
    const messageWidgets = widgets || null;

    // Check if widgets contain text components (A2UI format)
    const hasTextWidget = messageWidgets && messageWidgets.some(w => w.type === 'text');

    // Only show content if no widgets or no text widget in widgets (backward compatibility)
    const showContent = content && (!messageWidgets || !hasTextWidget);

    return (
      <div>
        {renderAgentStates()}
        {showContent && <MarkdownContent text={content} />}
        {messageWidgets && (
          <WidgetBlocks
            widgets={messageWidgets}
            onEvent={handleA2UIEvent}
          />
        )}
      </div>
    );
  };


  return (
    <div className={`message ${isUser ? 'user' : 'assistant'}`}>
      <div className="message-content">
        {getMessageContent()}
      </div>
    </div>
  );
}

export default Message;
